import { create } from "zustand";

const useLoaderStore = create((set) => ({
  activeRequests: 0,
  // Number of on-page loading regions (tables showing their own skeleton).
  // While any are active the global bar stays hidden so it never doubles up.
  scopedLoaders: 0,
  showLoader: () => set((s) => ({ activeRequests: s.activeRequests + 1 })),
  hideLoader: () => set((s) => ({ activeRequests: Math.max(0, s.activeRequests - 1) })),
  enterScoped: () => set((s) => ({ scopedLoaders: s.scopedLoaders + 1 })),
  leaveScoped: () => set((s) => ({ scopedLoaders: Math.max(0, s.scopedLoaders - 1) })),
}));

// Callable outside React components (e.g. axios interceptors)
export const showLoader = () => useLoaderStore.getState().showLoader();
export const hideLoader = () => useLoaderStore.getState().hideLoader();

export default useLoaderStore;
